import { render } from "./AmountNumber.vue?vue&type=template&id=6162ae88&scoped=true"
import script from "./AmountNumber.vue?vue&type=script&lang=js"
export * from "./AmountNumber.vue?vue&type=script&lang=js"

import "./AmountNumber.vue?vue&type=style&index=0&id=6162ae88&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6162ae88"]])

export default __exports__